import React, { useContext } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import useLogout from '../hook/UseLogout';
import { UserContext } from '../hook/UserLoginData';
const DashboardHeader   = () => {
  const logout = useLogout();
  const  {user} = useContext(UserContext);

return (
    <Navbar expand="lg" className="px-3" style={{ backgroundColor: '#10216E', color: '#fff' }}>
        <Navbar.Brand href="#" className="text-white">
       <img src="/coforge-logo.png" alt="Coforge logo" className='me-2 printable-logo'/>
      <img src="/aurenity-logo-1.png" alt="Aurenity logo" className='printable-logo'/>
      <img src="/logos.png" alt="Loss Runs Extraction logo" className='logo'/>
            <span className='pl-2' style={{paddingLeft:"20px"}}>Loss Runs Extraction</span>
        </Navbar.Brand>
        <Nav className="ms-auto">
          
          <Nav.Link onClick={logout} className="text-white">
          <i className="fas fa-sign-out-alt"></i> 
            <span> Logout </span>
          </Nav.Link>

          <Nav.Link href="#" className="text-white">
          <i className="fas fa-user"></i> 
            <span> {user} </span>
          </Nav.Link>

        </Nav>
      </Navbar>
)

}

export default DashboardHeader;